module.exports = __webpack_public_path__ + "media/stylesheets/flag-icon-css/flags/1x1/pe-83c26459858b4334c435886c37cc8379.svg";